module.exports = __webpack_public_path__ + "static/img/aboutBanner4.35600cf9.png";